export enum Color {
  PitchBlack = "#000000",
  Black = "#333333",
  White = "#FFFFFF",
  MidnightBlue = "#032A41",
  BurntSienna = "#2D8A5B",
  ChampagnePink = "#FEDC97",
  LightPear = "#B5B682",
  Positive = "#C7E2CF",
  Destructive = "#DA5552",
  SeaBlue600 = "#7990A0",
  SeaBlue500 = "#B1BFC8",
  SeaBlue400 = "#BCC7CF",
  SeaBlue300 = "#D8DFE4",
  SeaBlue200 = "#EFF2F4",
  Disabled = "#D8DFE4",
  Warning = "#ffc6c4",
  LightWarning = "#FCEBEB",
  LightGrey = "#FAFAFA",
  LightGrey02 = "#F5F5F5",
  LightGrey03 = "#F0F0F0",
  LightGrey04 = "#BCC0C4",
  LighterPositive = "#4CAF50",
  LighterDestructive = "#F44336",
  DarkerChampagnePink = "#F5D56C",
  ModernGreen = "#388E3C",
  LighterYellow = "#FFE499",
  Charcoal = "#3E2723",
  ActionColor = "#E1F4FF",
  DarkGrey = "#525557",
  Grey = "#BFBFBF",
  InputTextColor = "#1f2937",
  Muted = "#6B7280",
}

export enum ColorV2 {
  Blue1 = "#0F2A40",
  Blue2 = "#2E4456",
  Blue3 = "#4E5E6D",
  Blue4 = "#6E7884",
  Blue5 = "#B3B6BE",
  Blue6 = "#DADFE2",
  Blue7 = "#F7F8F9",
  PositiveGreen = "#3CB371",
  NegativeRed = "#D34E4E",
  White = "#FFFFFF",
  SimflexityGreen = "#2C895A",
  BookedGreen = "#2C895A",
  ProgressCompleted = "#D7E6DF",
  ProgressUpcoming = "#D9D9D9",
  AbsenceLightBlue = "#C0D4E5",
  WithdrawnPink = "#E9A8A8",
  DeclinedRed = "#D9534F",
  OfferedYellow = "#F7C948",
  NotFilledGrey = "#536271",
  UnplannedAbsenceYellow = "#F4E2C2",
  TimeReportedBlue = "#4A90E2",
  ElectricBlue = "#2D8DDB",
  DarkAmbigiousYellow = "#D19D00",
  AbsentPurple = "#6A54CD",
}
